import { render, staticRenderFns } from "./personCenterLayout.vue?vue&type=template&id=202481af&scoped=true&"
import script from "./personCenterLayout.vue?vue&type=script&lang=js&"
export * from "./personCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./personCenterLayout.vue?vue&type=style&index=0&id=202481af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.3.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202481af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/erp_Product/erp_front/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('202481af', component.options)
    } else {
      api.reload('202481af', component.options)
    }
    module.hot.accept("./personCenterLayout.vue?vue&type=template&id=202481af&scoped=true&", function () {
      api.rerender('202481af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/personCenterLayout.vue"
export default component.exports